import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LinearProgress from '@mui/material/LinearProgress';
import { useToastNotificationContext, useCalculateProgress } from '@hooks';
import { ROUTES } from '@constants';
import { useStyles, useStylesLinearProgress } from './styles';

function ErrorScreen() {
  const timingBeforeRedirectMs = 500;

  const {
    progress,
    inProcessing,
    secondsLeftBeforeRedirect,
  } = useCalculateProgress();

  const {
    setToastNotification,
    toastNotification,
  } = useToastNotificationContext();
  const { toastKeyTranslate: key } = toastNotification;
  const { t } = useTranslation('errorNotifications');

  const classesLinearProgress = useStylesLinearProgress();
  const classes = useStyles();
  const history = useHistory();

  if (!inProcessing) {
    setTimeout(() => {
      history.push(ROUTES.SLIDER_SCREEN, {
        from: ROUTES.ERROR_SCREEN,
      });

      setToastNotification({
        isShowToast: false,
        toastType: 'error',
        toastMessage: '',
        toastKeyTranslate: '',
        errorCode: '',
      });
    }, timingBeforeRedirectMs);
  }
  return (
    <div className={classes.screen}>
      <div className={classes.content}>
        <h2 className={classes.title}>{t(`${key}.somethingWrong`)}</h2>
        {inProcessing ? (
          <div>
            <div className={classes.text}>
              <div>{t(`${key}.youRedirected`)}</div>
              <div className={classes.seconds}>{secondsLeftBeforeRedirect}</div>
              <div>
                {secondsLeftBeforeRedirect >= 2
                  ? t(`${key}.seconds`)
                  : t(`${key}.second`)}
              </div>
            </div>
            <LinearProgress
              value={progress}
              variant="determinate"
              classes={classesLinearProgress}
            />
          </div>
        ) : (
          <p className={classes.redirectText}>{t(`${key}.redirect`)}</p>
        )}
      </div>
    </div>
  );
}

export default ErrorScreen;
